import {takeEvery} from 'redux-saga/effects'

import {
  ADD_STORE_ITEM,
  DELETE_STORE_ITEMS_IN_BULK,
  DELETE_STORE_ITEM_BY_ID,
  GENERATE_BARCODE_PRINT_REPORT,
  GENERATE_BARCODE_STORE_ITEM,
  GET_ISSUE_SOLD_STOCK_REPORT,
  GET_PURCHASE_ORDER_REPORT,
  GET_STOCK_REPORT,
  GET_STORE_ITEM_BY_ID,
  GET_STORE_ITEM_LIST,
  GET_STORE_ITEM_PERMITTED_TAGS,
  GET_STORE_ITEM_TAGS,
  GET_TRANSFER_ITEM_LIST,
  SCAN_LOOKUP_STORE_ITEM,
  STORE_ITEM_HISTORY,
  TRANSFER_ITEM_TYPE,
  UPDATE_STORE_ITEM,
} from '../../../Actions/StoreItems/ActionTypes/ApiActionTypes'
import {
  ADD_STORE_ITEM_PACKAGE,
  DELETE_STORE_ITEM_PACKAGE_BY_ID,
  DELETE_STORE_PACKAGE_ITEMS_IN_BULK,
  GET_STORE_ITEM_PACKAGE_BY_ID,
  GET_STORE_ITEM_PACKAGE_LIST,
  UPDATE_STORE_ITEM_PACKAGE,
} from '../../../Actions/StoreItems/Packages/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_STORE_ITEM_LIST, fetchData)
  yield takeEvery(GET_STORE_ITEM_TAGS, fetchData)
  yield takeEvery(DELETE_STORE_ITEM_BY_ID, fetchData)
  yield takeEvery(GET_STORE_ITEM_BY_ID, fetchData)
  yield takeEvery(DELETE_STORE_ITEMS_IN_BULK, fetchData)
  yield takeEvery(UPDATE_STORE_ITEM, fetchData)
  yield takeEvery(ADD_STORE_ITEM, fetchData)
  yield takeEvery(GET_STORE_ITEM_PACKAGE_LIST, fetchData)
  yield takeEvery(DELETE_STORE_ITEM_PACKAGE_BY_ID, fetchData)
  yield takeEvery(GET_STORE_ITEM_PACKAGE_BY_ID, fetchData)
  yield takeEvery(DELETE_STORE_PACKAGE_ITEMS_IN_BULK, fetchData)
  yield takeEvery(UPDATE_STORE_ITEM_PACKAGE, fetchData)
  yield takeEvery(ADD_STORE_ITEM_PACKAGE, fetchData)
  yield takeEvery(GET_STORE_ITEM_PERMITTED_TAGS, fetchData)
  yield takeEvery(GET_STOCK_REPORT, fetchData)
  yield takeEvery(GET_PURCHASE_ORDER_REPORT, fetchData)
  yield takeEvery(GET_ISSUE_SOLD_STOCK_REPORT, fetchData)
  yield takeEvery(STORE_ITEM_HISTORY, fetchData)
  yield takeEvery(TRANSFER_ITEM_TYPE, fetchData)
  yield takeEvery(GET_TRANSFER_ITEM_LIST, fetchData)
  yield takeEvery(SCAN_LOOKUP_STORE_ITEM, fetchData)
  yield takeEvery(GENERATE_BARCODE_STORE_ITEM, fetchData)
  yield takeEvery(GENERATE_BARCODE_PRINT_REPORT, fetchData)
}

export default dataSaga
